import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Offers from './offers/Offers';
import Pending from './pending/Pending';
import Accepted from './accepted/Accepted';
import Rejected from './rejected/Rejected';
import 'react-accessible-accordion/dist/fancy-example.css';
import Advertisement from '../../shared/_advertisement';
import PanelHeader from '../../shared/panel/_PanelHeader';
import PanelBody from '../../shared/panel/_PanelBody';
import Panel from '../../shared/panel/_Panel';

class Index extends React.Component {
  render() {
    return (
      <Panel className={ 'trade-post-container' } >
        <Advertisement />
        <PanelHeader className='panel__header panel__header--open-books'>Trade Post</PanelHeader>
        <PanelBody>
          <Tabs>
            <TabList>
              {/* <Tab>Offers</Tab> */}
              <Tab>Pending</Tab>
              <Tab>Accepted</Tab>
              <Tab>Rejected</Tab>
            </TabList>
            {/* <TabPanel>
              <Offers />
            </TabPanel> */}
            <TabPanel>
              <Pending />
            </TabPanel>
            <TabPanel>
              <Accepted />
            </TabPanel>
            <TabPanel>
              <Rejected />
            </TabPanel>
          </Tabs>
        </PanelBody>
      </Panel>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/Index.jsx